export default {
  returnFormattedValue(value = '') {
    const onlyNumbers = value.replace(/\D/g, '');

    if (onlyNumbers.length === 11 && onlyNumbers.startsWith('0800'))
      return `${onlyNumbers.slice(0, 4)} ${onlyNumbers.slice(4, 7)} ${onlyNumbers.slice(7)}`;

    if (onlyNumbers.length === 8 && onlyNumbers.startsWith('4004'))
      return `${onlyNumbers.slice(0, 4)}-${onlyNumbers.slice(4)}`;

    if (onlyNumbers.length === 10)
      return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2, 6)}-${onlyNumbers.slice(6)}`;

    if (onlyNumbers.length === 11)
      return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2, 7)}-${onlyNumbers.slice(7)}`;

    return value;
  },
};
